<template>
  <div v-if="isFilterLoaded">
    <template v-for="(bucket, index) in buckets">
      <checkbox
        :key="bucket.value"
        :bucket="bucket"
        :filterName="filterName"
        :class="{ 'bg-white-light': !isEven(index), 'px-3': !filter.collapsed }"
        hideCount
        :isLocked="isLocked"
        @selected="handleCheckbox">
      </checkbox>
    </template>
  </div>
</template>

<script>
import Checkbox from '@/components/search/Checkbox'

export default {
  name: 'bucketSet',
  components: {
    Checkbox
  },
  props: {
    isFilterLoaded: {
      type: Boolean,
      default: false
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    filterName: {
      type: String,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  computed: {
    buckets () {
      if (!this.isFilterLoaded) return []
      return this.sortBuckets(this.filter.buckets)
    }
  },
  methods: {
    sortBuckets (buckets) {
      return buckets.slice().sort((a, b) => b.active - a.active || a.order - b.order)
    },
    handleCheckbox (bucket) {
      bucket.active = !bucket.active
      this.$emit('setToggled', bucket)
    }
  }
}
</script>
